import getLocale from '../getLocale';
/**
 * Maps locale to CommerceTools locale
 *
 * @todo Revisit this function.
 * @see getLocale
 * @see parseLocale
 * @see parseLocaleFromPath
 *
 * @param {boolean} [isFull=false] - Flag isFull. If set to false locale will be retrieved.
 * Otherwise, language will be retrieved.
 * @return - Language or locale depending on input parameter isFull.
 *
 * @example
 * // returns "en"
 * getCommerceLocal()
 *
 * @example
 * // returns "en-GB"
 * getCommerceLocal(true)
 */
const getCommerceLocal = (isFull = false) => {
    const locale = getLocale('mixed');
    return isFull ? locale.replace('_', '-') : locale.split('_')[0];
};
export default getCommerceLocal;
//# sourceMappingURL=getCommerceLocal.js.map